export default __webpack_public_path__ + "static/media/C_Carpet.bfcca5f2.jpg";